import type { Organisatie } from '@models/Organisatie'

import { apiClient } from '../../gateways/api'

export { fetchOrganisaties }

const fetchOrganisaties = async (): Promise<Organisatie[]> => {
  const { data } = await apiClient({
    url: '/rest/organisatie',
    method: 'GET',
  })

  return data
}
